import {connect} from 'react-redux';
import React, {Component} from 'react';

import {deleteExternalCalendar} from '../../actions/ExternalCalendars';

const defaultProps = {
    createExternalCalendar: externalCalendarCreateCommand => {
    },
    deleteExternalCalendar: calendarId => {
    }
};

class ExternalCalendars extends Component {
    constructor(props) {
        super(props);
    }

    handleExternalCalendarDeleteClick(event, calendarId) {
        event.preventDefault();

        this.props.deleteExternalCalendar(calendarId).then(() => {
            this.props.onDeleteExternalCalendar();
        });
    }

    render() {
        const {i18n} = this.props;

        return (
            <div className="clearfix sync_options mt30">
                <div className="tablebox middle auto margin">
                    <div>
                        <p>{i18n['creatingObjectPage.calendarsToSync']}:</p>
                    </div>
                    <div>
                        <span className="info inline">
                            <i className="fa fa-question-circle"/>
                            <span>{i18n['creatingObjectPage.theCalendar.hint2']}</span>
                        </span>
                    </div>
                </div>

                <div className="tablebox middle auto margin sync_row">
                    {this.props.externalCalendars !== null && this.props.externalCalendars.map(elem => (
                        <div key={elem.id} className="external-calendar">
                            <div className="external-calendar_delete">
                                <a
                                    href=""
                                    onClick={event => this.handleExternalCalendarDeleteClick(event, elem.id)}
                                >
                                    <i className="fa fa-close"/>
                                </a>
                            </div>
                            <div className="external-calendar_title">
                                {elem.name}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="clearfix mt20 external-calendar-panel">
                    <a href="" className="button small red" onClick={(e) => {
                        e.preventDefault();
                        this.props.showImportModal();
                    }}>
                        <span>{i18n['creatingObjectPage.addACalendar']}</span>
                    </a>

                    <a href="" className="button small red" style={{float: 'right'}} onClick={(e) => {
                        e.preventDefault();
                        this.props.showExportModal();
                    }}>
                        <span>{i18n['creatingObjectPage.exportYourCalendar']}</span>
                    </a>
                </div>

                <div className="note small mt15">
                    * {i18n['creatingObjectPage.theCalendar.hint3']}
                </div>
            </div>
        )
    }
}

ExternalCalendars.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    objectId: state.creatingObjectPage.createdObject.id,
    externalCalendars: state.creatingObjectPage.createdObject.meta.externalCalendars
});

const mapDispatchToProps = {
    deleteExternalCalendar
};

export default connect(mapStateToProps, mapDispatchToProps)(ExternalCalendars);



// WEBPACK FOOTER //
// ./src/components/CreatingProperty/ExternalCalendars.js